module.exports = __webpack_public_path__ + "img/MotorWithoutVFD.c5f9ad5e.png";